import { memo } from 'react';

import InsertRowAboveIconSVG from '@/assets/insert-row-above-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const IInsertRowAboveIcon = (props: Omit<IconProps, 'SVGComponent'>) => (
  <Icon SVGComponent={InsertRowAboveIconSVG} {...props} />
);

export const InsertRowAboveIcon = memo(IInsertRowAboveIcon) as typeof IInsertRowAboveIcon;
